import React, { useState } from "react";
import { HiOutlineUser, HiOutlineLockClosed, HiOutlineCog, HiOutlineCurrencyEuro } from "react-icons/hi";
import "../styles.css";
import logo from "../assets/logo.png";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setCargando(true);
    try {
      await onLogin(username, password);
    } catch (err) {
      setError(err.message || "Error al iniciar sesión");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box animate-fadeIn">
        <div className="login-brand">
          <div className="brand-logo">G</div>
          <span>GESTOR</span>
        </div>

        <div className="login-header">
          <h2>Bienvenido</h2>
          <p>Ingresa tus credenciales para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <HiOutlineUser className="input-icon" />
            <input
              type="text"
              placeholder="Usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <HiOutlineLockClosed className="input-icon" />
            <input
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <div className="login-portals-container">
            <a href="https://mantenimientos.vipeca.com" target="_blank" rel="noopener noreferrer" className="login-portal-link" title="Mantenimientos">
              <HiOutlineCog size={18} />
              <span>Mantenimientos</span>
            </a>
            <a href="https://subvenciones.vipeca.com" target="_blank" rel="noopener noreferrer" className="login-portal-link" title="Subvenciones">
              <HiOutlineCurrencyEuro size={18} />
              <span>Subvenciones</span>
            </a>
          </div>

          <button type="submit" className="botonAzul" disabled={cargando}>
            {cargando ? "Autenticando..." : "Iniciar Sesión"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
